import React, { useState, useCallback } from "react";
import { Flex, Text, Button, Illustration } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { DefaultModal } from "../../common/DefaultModal";
import {
  pageContainer,
  contentContainer,
  illustrationStyle,
  titleText,
  descriptionText,
  customContentWrapper,
  actionButtonsContainer,
} from "./styles_vanilla.css";
import { BaseLandingCardProps } from "./types";

export const BaseLandingCard: React.FC<BaseLandingCardProps> = ({
  illustrationName,
  title,
  description,
  onContinue,
  onSkip,
  isLoading = false,
  disableContinue = false,
  customContent,
  skipModalConfig,
}) => {
  const [showSkipModal, setShowSkipModal] = useState(false);

  const handleSkipClick = useCallback(() => {
    if (skipModalConfig) {
      setShowSkipModal(true);
    } else {
      onSkip();
    }
  }, [skipModalConfig, onSkip]);

  const handleSkipConfirm = useCallback(() => {
    setShowSkipModal(false);
    onSkip();
  }, [onSkip]);

  const handleSkipCancel = useCallback(() => {
    setShowSkipModal(false);
  }, []);

  return (
    <>
      <div className={pageContainer}>
        <Flex className={contentContainer} flexDirection="column" alignItems="center">
          <Illustration name={illustrationName} className={illustrationStyle} />
          <Text variant="h3" className={titleText} align="center">
            {title}
          </Text>
          <Text variant="regular-md" className={descriptionText} align="center">
            {description}
          </Text>

          {customContent && <div className={customContentWrapper}>{customContent}</div>}

          <Flex className={actionButtonsContainer} justifyContent="center" gap={Sizes.SM}>
            <Button variant="neutral" onClick={handleSkipClick} disabled={isLoading}>
              Skip
            </Button>
            <Button
              variant="primary"
              onClick={onContinue}
              isLoading={isLoading}
              disabled={isLoading || disableContinue}
            >
              Continue
            </Button>
          </Flex>
        </Flex>
      </div>

      {skipModalConfig && (
        <DefaultModal
          show={showSkipModal}
          title={skipModalConfig.title}
          body={skipModalConfig.body}
          negBtnText={skipModalConfig.cancelButtonText ?? "Cancel"}
          posBtnText={skipModalConfig.confirmButtonText ?? "Continue to skip"}
          onClose={handleSkipCancel}
          onConfirm={handleSkipConfirm}
        />
      )}
    </>
  );
};
